import React from "react";
import "./App.css";
import TradingViewChart from "./components/tradingViewChart";

function App() {
  return (
    <div className="App">
      <TradingViewChart />
    </div>
  );
}

export default App;
